<template>
  <tk-container
    disableScroll
    class="h-full bg-gray-100"
  >
    <div class="p-20 space-y-20">
      <div>
        <div class="text-22 font-600 text-black">
          Token 调试登录
        </div>
        <div class="text-12 text-gray mt-4">
          仅供调试使用，输入后端发放的 sessionToken 即可跳过正常登录流程。
        </div>
      </div>
      <van-field
        v-model="token"
        type="textarea"
        rows="2"
        autosize
        maxlength="200"
        show-word-limit
        class="rounded-12 bg-white"
        placeholder="请输入 sessionToken"
      />
      <van-button
        class="w-full"
        type="primary"
        color="linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)"
        :loading="loading"
        :disabled="!token"
        @click="handleLogin"
      >
        使用 token 登录
      </van-button>
      <van-button
        class="w-full"
        plain
        type="default"
        v-if="$store.getters.isLogin"
        @click="$push('/')"
      >
        返回首页
      </van-button>
      <van-button
        class="w-full"
        type="default"
        hairline
        v-if="$store.getters.isLogin"
        @click="clearLogin"
      >
        清除登录信息
      </van-button>
      <div
        v-if="error"
        class="text-12 text-red-500 bg-white rounded-12 p-10"
      >
        {{ error }}
      </div>
      <div
        v-if="userInfo"
        class="bg-white rounded-12 p-15 text-12 break-all leading-6"
      >
        <div class="text-14 font-600 mb-6">
          当前用户信息
        </div>
        <div>昵称：{{ userInfo.nickname || '-' }}</div>
        <div>用户 ID：{{ userInfo.objectId }}</div>
        <div>手机号：{{ userInfo.mobilePhoneNumber || '-' }}</div>
        <div>最近更新时间：{{ userInfo.updatedAt }}</div>
      </div>
    </div>
  </tk-container>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'AuthTokenDebug',
  data () {
    return {
      token: this.$route.query.token || '',
      loading: false,
      error: '',
      userInfo: null
    }
  },
  mounted () {
    if (this.token) {
      this.handleLogin()
    }
  },
  methods: {
    // 使用输入的 sessionToken 拉取用户信息并写入全局状态
    async handleLogin () {
      if (!this.token) {
        this.error = '请先填写 token'
        return
      }
      this.loading = true
      this.error = ''
      try {
        this.$tkParse.setSessionToken(this.token)
        const user = await this.$tkParse.getData('/users/me')
        if (!user || !user.objectId) {
          throw new Error('未获取到用户信息')
        }
        this.$cloudAjax.config.headers = {
          'X-Parse-Session-Token': this.token
        }
        this.$store.commit('setSessionToken', this.token)
        this.$store.commit('setUser', user)
        this.userInfo = user
        Toast.success('登录成功')
        const { redirect } = this.$route.query
        if (redirect) {
          this.$router.replace(redirect)
        }
      } catch (err) {
        this.$tkParse.setSessionToken('')
        this.$store.commit('setSessionToken', null)
        this.$store.commit('setUser', null)
        this.userInfo = null
        this.error = err && err.message ? err.message : '登录失败，请检查 token 是否有效'
        Toast.fail(this.error)
      } finally {
        this.loading = false
      }
    },
    // 清空 token 登录状态，方便重新调试
    clearLogin () {
      this.$tkParse.setSessionToken('')
      this.$cloudAjax.config.headers = {}
      this.$store.commit('setSessionToken', null)
      this.$store.commit('setUser', null)
      this.userInfo = null
      this.error = ''
      Toast.success('已清除登录信息')
    }
  }
}
</script>

<style scoped lang="scss">
.space-y-20 > * + * {
  margin-top: 20px;
}
</style>
